function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from "react";
import IntlMessage from '../commons/Intl';
import { Action, AuthoringConfirm, AuthoringSequence, Errors, Label, Placeholder } from "../commons/IntlMessages";
import { ActionType } from "../enum/ActionType";
var defaultLanguage = 'ja';
var intl = new IntlMessage(defaultLanguage);
var language = window.navigator.language.substring(0, 2) === 'ja' ? 'ja' : 'en';
intl.setLanguage(language);

var SPACE_REG_EXP = function SPACE_REG_EXP() {
  return /[\s\n\t\r\uFEFF\u200b]+/g;
}; // 確認ダイアログモーダル

/**
 * モード
 */


export var Mode;

(function (Mode) {
  /**
   * なし
   */
  Mode[Mode["None"] = 0] = "None";
  /**
   * セッションエラー
   */

  Mode[Mode["SequenceError"] = 1] = "SequenceError";
  /**
   * セッション確認
   */

  Mode[Mode["SequenceConfirm"] = 2] = "SequenceConfirm";
  /**
   * インタラクションエラー
   */

  Mode[Mode["InteractionError"] = 3] = "InteractionError";
  /**
   * インタラクション確認
   */

  Mode[Mode["InteractionConfirm"] = 4] = "InteractionConfirm";
  /**
   * シナリオグループ名前の変更
   */

  Mode[Mode["SequenceGroupRenameInput"] = 5] = "SequenceGroupRenameInput";
  /**
   * シナリオグループ複製
   */

  Mode[Mode["SequenceGroupDuplicateInput"] = 6] = "SequenceGroupDuplicateInput";
  /**
   * シナリオグループ削除確認
   */

  Mode[Mode["SequenceGroupDeleteConfirm"] = 7] = "SequenceGroupDeleteConfirm";
  /**
   * シナリオグループ新規作成
   */

  Mode[Mode["SequenceGroupCreateNewInput"] = 8] = "SequenceGroupCreateNewInput";
})(Mode || (Mode = {}));
/**
 * メインコンポーネント
 */


var MainComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(MainComponent, _React$Component);

  var _super = _createSuper(MainComponent);

  /**
   * フィールド変数の初期化を行います。
   *
   * @param props プロップス
   */
  function MainComponent(props) {
    var _this$props$originalV, _this$props$originalV2;

    var _this;

    _classCallCheck(this, MainComponent);

    _this = _super.call(this, props);
    var inputValue = "";
    var useAuthoring = false;

    switch (_this.props.mode) {
      case Mode.SequenceGroupRenameInput:
        inputValue = (_this$props$originalV = _this.props.originalValue) !== null && _this$props$originalV !== void 0 ? _this$props$originalV : "";
        break;

      case Mode.SequenceGroupDuplicateInput:
        inputValue = intl.format(AuthoringSequence.DuplicateSequenceGroup, {
          name: (_this$props$originalV2 = _this.props.originalValue) !== null && _this$props$originalV2 !== void 0 ? _this$props$originalV2 : ""
        });
        break;

      case Mode.SequenceGroupDeleteConfirm:
        var currentGroup = _this.props.currentGroup;

        var targetGroup = _this.props.sequenceTimeline.SequenceGroups.filter(function (g) {
          return g.GroupNo != currentGroup.GroupNo;
        });

        for (var i = 0; i < targetGroup.length; i++) {
          for (var j = 0; j < targetGroup[i].Sequences.length; j++) {
            if (targetGroup[i].Sequences[j].Actions[0].ActionType == ActionType.SwitchGroup && targetGroup[i].Sequences[j].Actions[0].MotionName == currentGroup.GroupNo.toString()) {
              useAuthoring = true;
              break;
            }

            if (useAuthoring) break;

            for (var k = 0; k < targetGroup[i].Sequences[j].Actions[0].Conditions.length; k++) {
              if (targetGroup[i].Sequences[j].Actions[0].Conditions[k].ActionType == ActionType.SwitchGroup && targetGroup[i].Sequences[j].Actions[0].Conditions[k].IsOn && targetGroup[i].Sequences[j].Actions[0].Conditions[k].ActionValue == currentGroup.GroupNo.toString()) {
                useAuthoring = true;
                break;
              }
            }
          }

          if (useAuthoring) break;
        }

        if (!useAuthoring) {
          var interactions = _this.props.interactionTimeline.Interactions;

          for (var i = 0; i < interactions.length; i++) {
            if (interactions[i].Actions[0].ActionType == ActionType.SwitchGroup && interactions[i].Actions[0].MotionName == currentGroup.GroupNo.toString()) {
              useAuthoring = true;
              break;
            }

            if (useAuthoring) break;

            for (var j = 0; j < interactions[i].Actions[0].Conditions.length; j++) {
              if (interactions[i].Actions[0].Conditions[j].ActionType == ActionType.SwitchGroup && interactions[i].Actions[0].Conditions[j].IsOn && interactions[i].Actions[0].Conditions[j].ActionValue == currentGroup.GroupNo.toString()) {
                useAuthoring = true;
                break;
              }
            }
          }
        }

        break;
    }

    _this.state = {
      Modal: null,
      InputValue: inputValue,
      useAuthoring: useAuthoring,
      ErrorMessages: []
    };
    return _this;
  }
  /**
   * ComponentがDOMツリーに追加された状態で呼ばれるDOMに関わる初期化処理
   */


  _createClass(MainComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var modal = $('#SessionAuthoringConfirmDialogModal');
      this.setState({
        Modal: modal
      });
      modal.modal({
        backdrop: 'static',
        keyboard: false
      });
      var list = document.querySelectorAll(".modal-backdrop");

      for (var i = 0; i < list.length; i++) {
        if (!list[i].classList.contains("nested")) {
          list[i].classList.add("nested");
        }
      } // ポップアップが完全に非表示になった時のイベント。


      modal.on("hidden.bs.modal", function (e) {
        var list = document.querySelectorAll(".modal-backdrop");

        for (var i = 0; i < list.length; i++) {
          if (list[i].classList.contains("nested")) {
            list[i].classList.remove("nested");
          }
        }

        _this2.props.onHidden();
      });
    }
    /**
     * 「修正する」ボタン押下時の処理を行います。
     */

  }, {
    key: "onEdit",
    value: function onEdit() {
      if (this.state.Modal == null) {
        throw Error();
      }

      this.state.Modal.modal('hide');
    }
    /**
     * 「無視する」ボタン押下時の処理を行います。
     */

  }, {
    key: "onIgnore",
    value: function onIgnore() {
      var _this3 = this;

      if (this.state.Modal == null) {
        throw Error();
      }

      this.props.onIgnore(function () {
        if (_this3.state.Modal == null) {
          throw Error();
        }

        _this3.state.Modal.modal('hide');
      });
    }
    /**
     * 「登録」ボタン押下時の処理を行います。
     */

  }, {
    key: "onInput",
    value: function onInput() {
      var _this4 = this;

      if (this.state.Modal == null) {
        throw Error();
      }

      this.state.ErrorMessages.length = 0;

      if (this.state.InputValue != null) {
        var text = this.state.InputValue;
        var chars = text.replace(SPACE_REG_EXP(), '');

        if (chars.length == 0) {
          this.state.ErrorMessages.push(intl.format(Errors.InputRequired));
        }

        if (this.props.mode == Mode.SequenceGroupCreateNewInput || text != this.props.originalValue) {
          if (this.props.sequenceTimeline.SequenceGroups != null) {
            if (this.props.sequenceTimeline.SequenceGroups.filter(function (g) {
              return g.GroupName == text;
            }).length > 0) {
              this.state.ErrorMessages.push(intl.format(Errors.DuplicateSequenceGroupName));
            }
          }
        }
      }

      if (this.state.ErrorMessages.length != 0) {
        this.setState({
          ErrorMessages: this.state.ErrorMessages
        });
        return;
      }

      this.props.onInput(this.state.InputValue, function () {
        if (_this4.state.Modal == null) {
          throw Error();
        }

        _this4.state.Modal.modal('hide');
      });
    }
    /**
     * 「はい」ボタン押下時の処理を行います。
     */

  }, {
    key: "onYes",
    value: function onYes() {
      var _this5 = this;

      if (this.state.Modal == null) {
        throw Error();
      }

      this.props.onYes(function () {
        if (_this5.state.Modal == null) {
          throw Error();
        }

        _this5.state.Modal.modal('hide');
      });
    }
    /**
     * 「いいえ」ボタン押下時の処理を行います。
     */

  }, {
    key: "onNo",
    value: function onNo() {
      var _this6 = this;

      if (this.state.Modal == null) {
        throw Error();
      }

      this.props.onNo(function () {
        if (_this6.state.Modal == null) {
          throw Error();
        }

        _this6.state.Modal.modal('hide');
      });
    }
    /**
     * 入力値を更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateInputValue",
    value: function updateInputValue(e) {
      this.setState({
        InputValue: e.target.value.substring(0, e.target.maxLength)
      });
    }
    /**
     * レンダラー
     */

  }, {
    key: "render",
    value: function render() {
      var _this7 = this,
          _this$state$InputValu,
          _this$state$InputValu2,
          _this$state$InputValu3;

      var message = "";
      var warningMessage = "";

      if (this.props.mode == Mode.SequenceError) {
        message = intl.format(AuthoringConfirm.ErrorMessage);
        message = message.replace(/{type}/g, intl.format(Label.Sequence));
      } else if (this.props.mode == Mode.SequenceConfirm) {
        message = intl.format(AuthoringConfirm.ConfirmMessage);
        message = message.replace(/{type}/g, intl.format(Label.Sequence));
      } else if (this.props.mode == Mode.InteractionError) {
        message = intl.format(AuthoringConfirm.ErrorMessage);
        message = message.replace(/{type}/g, intl.format(Label.Interaction));
      } else if (this.props.mode == Mode.InteractionConfirm) {
        message = intl.format(AuthoringConfirm.ConfirmMessage);
        message = message.replace(/{type}/g, intl.format(Label.Interaction));
      } else if (this.props.mode == Mode.SequenceGroupDeleteConfirm) {
        if (this.state.useAuthoring) {
          warningMessage = intl.format(AuthoringConfirm.SequenceGroupDeleteConfirmWarningMessage);
        }

        message = intl.format(AuthoringConfirm.SequenceGroupDeleteConfirmMessage);
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "modal fade",
        id: "SessionAuthoringConfirmDialogModal",
        role: "dialog"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-dialog modal-lg",
        role: "document"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-content"
      }, this.state.ErrorMessages.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "validation-summary-errors alert alert-danger"
      }, /*#__PURE__*/React.createElement("ul", null, this.state.ErrorMessages.map(function (x, i) {
        return /*#__PURE__*/React.createElement("li", {
          key: i
        }, x);
      }))), /*#__PURE__*/React.createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-title"
      }, (this.props.mode == Mode.SequenceError || this.props.mode == Mode.InteractionError) && [/*#__PURE__*/React.createElement("img", {
        className: "modalIcon",
        width: "40",
        height: "42",
        src: "/assets/img/information_icon_side.svg"
      }), /*#__PURE__*/React.createElement("h3", null, intl.format(AuthoringConfirm.ErrorTitle))], (this.props.mode == Mode.SequenceConfirm || this.props.mode == Mode.InteractionConfirm) && [/*#__PURE__*/React.createElement("img", {
        className: "modalIcon",
        width: "40",
        height: "42",
        src: "/assets/img/information_icon_side.svg"
      }), /*#__PURE__*/React.createElement("h3", null, intl.format(AuthoringConfirm.ConfirmTitle))], this.props.mode == Mode.SequenceGroupRenameInput && [/*#__PURE__*/React.createElement("img", {
        className: "modalIcon",
        width: "40",
        height: "42",
        src: "/assets/img/Icon_Edit_Grey.svg"
      }), /*#__PURE__*/React.createElement("h3", null, intl.format(AuthoringConfirm.SequenceGroupRenameInputTitle))], this.props.mode == Mode.SequenceGroupDuplicateInput && [/*#__PURE__*/React.createElement("img", {
        className: "modalIcon",
        width: "40",
        height: "42",
        src: "/assets/img/Icon_Duplicate_Grey.svg"
      }), /*#__PURE__*/React.createElement("h3", null, intl.format(AuthoringConfirm.SequenceGroupDuplicateInputTitle))], this.props.mode == Mode.SequenceGroupDeleteConfirm && [/*#__PURE__*/React.createElement("img", {
        className: "modalIcon",
        width: "40",
        height: "42",
        src: "/assets/img/Icon_Delete_Grey.svg"
      }), /*#__PURE__*/React.createElement("h3", null, intl.format(AuthoringConfirm.SequenceGroupDeleteConfirmTitle))], this.props.mode == Mode.SequenceGroupCreateNewInput && [/*#__PURE__*/React.createElement("img", {
        className: "modalIcon",
        width: "40",
        height: "42",
        src: "/assets/img/Icon_Add_ScenarioGroup.svg"
      }), /*#__PURE__*/React.createElement("h3", null, intl.format(AuthoringConfirm.SequenceGroupCreateNewInputTitle))]), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "modal-close",
        "data-dismiss": "modal",
        "aria-label": "Close",
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7"))), (this.props.mode == Mode.SequenceError || this.props.mode == Mode.InteractionError) && [/*#__PURE__*/React.createElement("div", {
        className: "modal-body row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-8 mx-auto"
      }, message.split('\\n').map(function (str, index) {
        return /*#__PURE__*/React.createElement(React.Fragment, {
          key: index
        }, str, /*#__PURE__*/React.createElement("br", null));
      }))), /*#__PURE__*/React.createElement("div", {
        className: "modal-footer justify-content-center"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        onClick: this.onEdit.bind(this),
        className: "btn btn-default",
        tabIndex: -1
      }, intl.format(Action.Edit)), /*#__PURE__*/React.createElement("button", {
        type: "button",
        onClick: this.onIgnore.bind(this),
        className: "btn btn-primary",
        tabIndex: -1
      }, intl.format(Action.Ignore)))], (this.props.mode == Mode.SequenceConfirm || this.props.mode == Mode.InteractionConfirm) && [/*#__PURE__*/React.createElement("div", {
        className: "modal-body row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-8 mx-auto"
      }, message.split('\\n').map(function (str, index) {
        return /*#__PURE__*/React.createElement(React.Fragment, {
          key: index
        }, str, /*#__PURE__*/React.createElement("br", null));
      }))), /*#__PURE__*/React.createElement("div", {
        className: "modal-footer justify-content-center"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        onClick: this.onNo.bind(this),
        className: "btn btn-default",
        tabIndex: -1
      }, intl.format(Action.No)), /*#__PURE__*/React.createElement("button", {
        type: "button",
        onClick: this.onYes.bind(this),
        className: "btn btn-primary",
        tabIndex: -1
      }, intl.format(Action.Yes)))], this.props.mode == Mode.SequenceGroupRenameInput && [/*#__PURE__*/React.createElement("div", {
        className: "modal-body row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-9 mx-auto"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label",
        htmlFor: "Name"
      }, intl.format(Label.Name)), /*#__PURE__*/React.createElement("div", {
        className: "col-9"
      }, /*#__PURE__*/React.createElement("input", {
        type: "text",
        className: "form-control",
        name: "Name",
        id: "Name",
        "data-val": "true",
        "data-val-nowhitespace": intl.format(Errors.InputRequired),
        maxLength: 40,
        onChange: function onChange(e) {
          return _this7.updateInputValue(e);
        },
        value: (_this$state$InputValu = this.state.InputValue) !== null && _this$state$InputValu !== void 0 ? _this$state$InputValu : "",
        tabIndex: 101,
        placeholder: intl.format(Placeholder.Letters, {
          value: "40"
        })
      }), /*#__PURE__*/React.createElement("span", {
        className: "text-danger",
        "data-valmsg-for": "Name",
        "data-valmsg-replace": "true",
        style: {
          fontSize: "16px"
        }
      }))))), /*#__PURE__*/React.createElement("div", {
        className: "modal-footer justify-content-center"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        onClick: this.onNo.bind(this),
        className: "btn btn-default",
        tabIndex: -1
      }, intl.format(Action.Back)), /*#__PURE__*/React.createElement("button", {
        type: "button",
        onClick: this.onInput.bind(this),
        className: "btn btn-primary",
        tabIndex: -1
      }, intl.format(Action.Entry)))], this.props.mode == Mode.SequenceGroupDuplicateInput && [/*#__PURE__*/React.createElement("div", {
        className: "modal-body row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-9 mx-auto"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label",
        htmlFor: "Name"
      }, intl.format(Label.DuplicateSource)), /*#__PURE__*/React.createElement("div", {
        className: "col-9"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-form-label"
      }, this.props.originalValue)))), /*#__PURE__*/React.createElement("div", {
        className: "col-9 mx-auto"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label",
        htmlFor: "Name"
      }, intl.format(Label.Name)), /*#__PURE__*/React.createElement("div", {
        className: "col-9"
      }, /*#__PURE__*/React.createElement("input", {
        type: "text",
        className: "form-control",
        name: "Name",
        id: "Name",
        "data-val": "true",
        "data-val-nowhitespace": intl.format(Errors.InputRequired),
        maxLength: 40,
        onChange: function onChange(e) {
          return _this7.updateInputValue(e);
        },
        value: (_this$state$InputValu2 = this.state.InputValue) !== null && _this$state$InputValu2 !== void 0 ? _this$state$InputValu2 : "",
        tabIndex: 101,
        placeholder: intl.format(Placeholder.Letters, {
          value: "40"
        })
      }), /*#__PURE__*/React.createElement("span", {
        className: "text-danger",
        "data-valmsg-for": "Name",
        "data-valmsg-replace": "true",
        style: {
          fontSize: "16px"
        }
      }))))), /*#__PURE__*/React.createElement("div", {
        className: "modal-footer justify-content-center"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        onClick: this.onNo.bind(this),
        className: "btn btn-default",
        tabIndex: -1
      }, intl.format(Action.Back)), /*#__PURE__*/React.createElement("button", {
        type: "button",
        onClick: this.onInput.bind(this),
        className: "btn btn-primary",
        tabIndex: -1
      }, intl.format(Action.Entry)))], this.props.mode == Mode.SequenceGroupDeleteConfirm && warningMessage != "" && [/*#__PURE__*/React.createElement("div", {
        className: "modal-body row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-8 mx-auto text-danger"
      }, warningMessage.split('\\n').map(function (str, index) {
        return /*#__PURE__*/React.createElement(React.Fragment, {
          key: index
        }, str, /*#__PURE__*/React.createElement("br", null));
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-8 mx-auto"
      }, message.split('\\n').map(function (str, index) {
        return /*#__PURE__*/React.createElement(React.Fragment, {
          key: index
        }, str, /*#__PURE__*/React.createElement("br", null));
      }))), /*#__PURE__*/React.createElement("div", {
        className: "modal-footer justify-content-center"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        onClick: this.onNo.bind(this),
        className: "btn btn-default",
        tabIndex: -1
      }, intl.format(Action.Back)), /*#__PURE__*/React.createElement("button", {
        type: "button",
        onClick: this.onYes.bind(this),
        className: "btn btn-primary",
        tabIndex: -1
      }, intl.format(Action.Delete)))], this.props.mode == Mode.SequenceGroupDeleteConfirm && warningMessage == "" && [/*#__PURE__*/React.createElement("div", {
        className: "modal-body row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-8 mx-auto"
      }, message.split('\\n').map(function (str, index) {
        return /*#__PURE__*/React.createElement(React.Fragment, {
          key: index
        }, str, /*#__PURE__*/React.createElement("br", null));
      }))), /*#__PURE__*/React.createElement("div", {
        className: "modal-footer justify-content-center"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        onClick: this.onNo.bind(this),
        className: "btn btn-default",
        tabIndex: -1
      }, intl.format(Action.Back)), /*#__PURE__*/React.createElement("button", {
        type: "button",
        onClick: this.onYes.bind(this),
        className: "btn btn-primary",
        tabIndex: -1
      }, intl.format(Action.Delete)))], this.props.mode == Mode.SequenceGroupCreateNewInput && [/*#__PURE__*/React.createElement("div", {
        className: "modal-body row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-9 mx-auto"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label",
        htmlFor: "Name"
      }, intl.format(Label.Name)), /*#__PURE__*/React.createElement("div", {
        className: "col-9"
      }, /*#__PURE__*/React.createElement("input", {
        type: "text",
        className: "form-control",
        name: "Name",
        id: "Name",
        "data-val": "true",
        "data-val-nowhitespace": intl.format(Errors.InputRequired),
        maxLength: 40,
        onChange: function onChange(e) {
          return _this7.updateInputValue(e);
        },
        value: (_this$state$InputValu3 = this.state.InputValue) !== null && _this$state$InputValu3 !== void 0 ? _this$state$InputValu3 : "",
        tabIndex: 101,
        placeholder: intl.format(Placeholder.Letters, {
          value: "40"
        })
      }), /*#__PURE__*/React.createElement("span", {
        className: "text-danger",
        "data-valmsg-for": "Name",
        "data-valmsg-replace": "true",
        style: {
          fontSize: "16px"
        }
      }))))), /*#__PURE__*/React.createElement("div", {
        className: "modal-footer justify-content-center"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        onClick: this.onNo.bind(this),
        className: "btn btn-default",
        tabIndex: -1
      }, intl.format(Action.Back)), /*#__PURE__*/React.createElement("button", {
        type: "button",
        onClick: this.onInput.bind(this),
        className: "btn btn-primary",
        tabIndex: -1
      }, intl.format(Action.Entry)))])));
    }
  }]);

  return MainComponent;
}(React.Component);

export { MainComponent as default };